import { availableBrandGroups, eroiIds, TvdMetricData } from "../../types/tvd-types";
import { Component, Input, Output, OnInit, EventEmitter } from "@angular/core";
import { compositeTilesConfig } from "../../types/tvd-metric-tiles-config";
import { UomOption } from "src/app/core/services/currency-uom.service";

@Component({
    selector: 'tvd-metric-group',
    templateUrl: './tvd-metric-group.component.html',
    styleUrls: ['./tvd-metric-group.component.scss'],
    standalone: false
})
export class TvdMetricGroupComponent implements OnInit {
     @Input() groupId: string = '';

     //title of the metric group
    @Input() groupTitle: string = '';

    //metric data of the metric group
    @Input() metricData: TvdMetricData[] = [];

    @Input() brandGroup: availableBrandGroups = availableBrandGroups.ALL;

    @Input() brands: string[] = [];

    //boolean on if the user is selecting metrics which affects the html template
    @Input() makingSelectionsState: boolean = false;

    //whether metric group has been selected or not
    @Input() isGroupSelected: boolean = false; //matches with bucketSelected booleans in old tvd code

    @Input() shouldShowCompositeMetric: boolean = false;

    @Input() measurementSystem: UomOption = 'Imperial';

    //Emitter which informs other components a metric group was selected/deselected, sending the title of the group
    @Output() groupMetricSelectionChange = new EventEmitter<string>();

    compositeMetricIds: eroiIds[] = [eroiIds.SOLID_WASTE];
    
    ngOnInit(): void {
        
    }

    /**
     * Toggles the metric group's selection and emits the selection change
     */
    public toggleBucketSelection() {
        this.isGroupSelected = !this.isGroupSelected;

        this.groupMetricSelectionChange.emit(this.groupTitle);
    }

    /**
     * Gets the count of how many metrics are being displayed. Since the metric group might hold some "empty" metrics
     * Might not need this now since empty metrics are not included in response from BE
     * @returns 
     */
    countDisplayedMetrics(): number {
        let itemCount: number = 0;
    
        for (let i = 0; i < this.metricData.length; i++) {
          if (!this.isDataZeroOrEmpty(this.metricData[i])) {
            itemCount++;
          }
        }
        return itemCount;
    }

    /**
     * Returns whether a metric is effectively empty. Used to parse out empty metric data when assigned
     * @param metricData data for one TVD metric
     * @returns whether the metric's display value is effectively empty or not
     */
    isDataZeroOrEmpty(metricData: TvdMetricData | undefined): boolean {
      if(metricData){
        return metricData.valueContribution == '0' && (metricData.monetaryContribution == '0' || metricData.monetaryContribution === '');
      }
      return true;
    }

    metricIsCompositeMetric(metricId: string): boolean {
      if (this.compositeMetricIds.includes(metricId as eroiIds)) {
        return true;
      }
      return false;
    }

    metricIsCompositeSubComponent(metricId: string): boolean {
      let solidWasteSubComponents = compositeTilesConfig.find(
        c => c.composite_tile_id === eroiIds.SOLID_WASTE
      )?.subcomponents;

      return solidWasteSubComponents?.includes(metricId as eroiIds) ?? false;
    }

    getComponentData(metricId: string): TvdMetricData | undefined {
      return this.metricData.find(metric => metric.id === metricId);
    }

    getSubComponentsData(parentComponentId: string): TvdMetricData[] {
      const composite = compositeTilesConfig.find(
        c => c.composite_tile_id === parentComponentId
      );
    
      if (!composite) {
        console.warn(`Composite tile not found for: ${parentComponentId}`);
        return [];
      }
    
      return composite.subcomponents
        .map(childId => this.getComponentData(childId))
        .filter((child): child is TvdMetricData => child !== undefined); //child is TvdMetricData => 
    }
}
